import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-end page-heading-toolbar" }
const _hoisted_3 = { class: "page-heading-toolbar--col" }
const _hoisted_4 = { class: "bundles-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Delete this bundle?")
  ])
], -1)

import { computed, ComputedRef, onBeforeMount, Ref, ref, watch } from "vue";
import PageMainHeading from "@/components/Layout/PageMainHeading.vue";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import AppTableController from "../../../components/Table/ts/AppTableController.vue";
import AppTable from "@/components/Table/ts/AppTable.vue";
import DeleteConfirmDialog from "@/components/ui/Modal/Dialog/instances/DeleteConfirmDialog.vue";
import UpdateBundleModal from "@/components/Packages/eSIM/UpdateBundleModal.vue";

import BtnContent from "../../../components/ui/Buttons/BtnContent.vue";
import DragAndDrop from "@/components/ui/DragAndDrop.vue";
import Dialog from "@/components/ui/Modal/Dialog/Dialog.vue";
import {
  ITableBodyRow,
  ITableHeadCell
} from "@/components/Table/ts/interfaces/TableStructure";

import { api } from "@/api/Api";
import { useStore } from "vuex";
import { useBaseTable } from "@/hooks/tables/useTable";
import { IBundle } from "@/api/services/packages/esim/location-packages/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ESIMBundles',
  setup(__props) {

const store = useStore();

const initialViewConfiguration = { page: 1, perPage: 10 };
const uploadLoading = ref(false);
const loading = ref(false);
const importModalOpened = ref(false);
const deleteModal = ref(false);
const editModal = ref(false);

const uploadProgress = ref(0);
const uploadSuccess: Ref<boolean | null> = ref(null);
const uploadErrorMessage = ref("");

const bundles: Ref<IBundle[]> = ref([] as IBundle[]);
const totalBundles = ref(0);
const currentBundle = ref({} as IBundle);

function hideImportModal() {
  if (uploadLoading.value) return;

  importModalOpened.value = false;
  uploadProgress.value = 0;
  uploadLoading.value = false;
  uploadErrorMessage.value = "";
  uploadSuccess.value = null;
}

const toggleDeleteModal = (value: boolean) => {
  deleteModal.value = value;

  if (!value) {
    currentBundle.value = {} as IBundle;
  }
};

const toggleEditModal = (value: boolean) => {
  editModal.value = value;

  if (!value) {
    currentBundle.value = {} as IBundle;
  }
};

const rows = computed(() => tableRefs.rows.value);
const cells: ComputedRef<ITableHeadCell[]> = computed(() => {
  return [
    {
      id: "i-product",
      label: "I Product",
      size: "md"
    },
    {
      id: "name",
      label: "Name",
      size: "xxl"
    }
  ];
});

const tableRefs = useBaseTable({
  initialViewConfiguration: { page: 1, perPage: 10 },
  model: computed(() => bundles.value),
  initialSortOptions: {},
  generateRows(bundlesList: IBundle[] = []): ITableBodyRow[] {
    if (!bundlesList) {
      return [];
    }
    return bundlesList.map(
      (bundle): ITableBodyRow => {
        const { i_product, name } = bundle;

        return {
          onClick: () => {},
          // actions: [
          //   {
          //     text: "Edit",
          //     onClick: () => {
          //       currentBundle.value = bundle;
          //       toggleEditModal(true);
          //     }
          //   },
          //   {
          //     text: "Delete",
          //     onClick: () => {
          //       currentBundle.value = bundle;
          //       toggleDeleteModal(true);
          //     }
          //   }
          // ],
          cells: [
            {
              label: i_product.toString()
            },
            {
              label: name
            }
          ]
        };
      }
    );
  },
  onViewConfigurationChanged: () => {
    fetchBundles();
  }
});

async function importFile(table: File) {
  uploadProgress.value = 0;
  uploadSuccess.value = null;
  uploadErrorMessage.value = "";

  uploadLoading.value = true;

  const { data } = await api.importBundle(table, (progress: number) => {
    if (uploadProgress.value === 0) {
      if (progress === 100) {
        const interval = setInterval(() => {
          uploadProgress.value += 0.6;
          if (uploadProgress.value >= 90) {
            clearInterval(interval);
          }
        }, 15);

        return;
      }

      uploadProgress.value = progress;
      return;
    }

    progress < 99 && (uploadProgress.value = progress);
  });

  uploadLoading.value = false;
  uploadProgress.value = 100;

  const isData = typeof data === "string";
  if (isData) {
    const msg = (data as unknown) as string;
    uploadErrorMessage.value = msg || "";
    uploadSuccess.value = false;
    return;
  }

  uploadSuccess.value = true;
  await fetchBundles();
}

async function fetchBundles() {
  const view = tableRefs?.viewConfiguration || initialViewConfiguration;

  await store.dispatch("setAppLoading", true);

  const { success, message, data: bundlesList } = await api.fetchBundles(view);

  if (!success && message) {
    return await store.dispatch("showErrorNotification", message);
  }

  await store.dispatch("setAppLoading", false);
  bundles.value = bundlesList.bundles as IBundle[];
  totalBundles.value = (bundlesList.total as number) ?? 0;
}

/*
async function editBundle(name: string) {
  loading.value = true;
  await store.dispatch("setAppLoading", true);

  const { success, message } = await api.editBundle(
    String(currentBundle.value.id),
    name
  );

  if (!success && message) {
    return await store.dispatch("showErrorNotification", message);
  }

  loading.value = false;
  await store.dispatch("setAppLoading", false);
  toggleEditModal(false);
}
*/

// async function deleteBundle() {
//   loading.value = true;
//   await store.dispatch("setAppLoading", true);
//
//   const { success, message } = await api.deleteBundle(
//     String(currentBundle.value.id)
//   );
//
//   if (!success && message) {
//     return await store.dispatch("showErrorNotification", message);
//   }
//
//   loading.value = false;
//   await store.dispatch("setAppLoading", false);
//   toggleDeleteModal(false);
// }

watch(
  () => importModalOpened.value,
  opened => {
    if (!opened) {
      uploadProgress.value = 0;
    }
  }
);

watch(
  () => importModalOpened.value,
  opened => {
    if (!opened) {
      uploadProgress.value = 0;
    }
  }
);

watch(
  () => loading.value,
  isLoading => {
    if (!isLoading) {
      fetchBundles();
    }
  }
);

onBeforeMount(() => {
  fetchBundles();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Dialog, {
      title: "Bundles upload",
      opened: importModalOpened.value,
      "can-close": !uploadLoading.value,
      onHide: hideImportModal
    }, {
      default: _withCtx(() => [
        _createVNode(DragAndDrop, {
          accepted: ['XLS', 'XLSX'],
          loading: uploadLoading.value,
          progress: uploadProgress.value,
          "upload-success": uploadSuccess.value,
          "upload-error": uploadErrorMessage.value,
          onFileChanged: importFile
        }, null, 8, ["loading", "progress", "upload-success", "upload-error"])
      ]),
      _: 1
    }, 8, ["opened", "can-close"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageMainHeading, { title: "Bundles" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AppButton, {
                size: "xl",
                type: "secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (importModalOpened.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(BtnContent, {
                    icon: "plus",
                    label: "Import File"
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(AppTableController, {
            "show-table": true,
            "empty-key": "bundles",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(AppTable, {
                "table-head": _unref(cells),
                "table-body": _unref(rows),
                "total-rows": totalBundles.value,
                "current-page": _unref(tableRefs).viewConfiguration.page,
                "per-page": _unref(tableRefs).viewConfiguration.perPage,
                "pagination-capture-key": "Bundles",
                onChangeViewConfiguration: _unref(tableRefs).changeViewConfiguration,
                onSort: _unref(tableRefs).changeSorting
              }, null, 8, ["table-head", "table-body", "total-rows", "current-page", "per-page", "onChangeViewConfiguration", "onSort"])
            ]),
            _: 1
          })
        ]),
        _createVNode(DeleteConfirmDialog, {
          opened: deleteModal.value,
          loading: loading.value,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (toggleDeleteModal(false))),
          onConfirm: _ctx.deleteBundle,
          onHide: _cache[2] || (_cache[2] = ($event: any) => (toggleDeleteModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["opened", "loading", "onConfirm"]),
        _createVNode(UpdateBundleModal, {
          "edit-data": { name: currentBundle.value.name },
          opened: editModal.value,
          loading: loading.value,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (toggleEditModal(false))),
          onSubmit: _ctx.editBundle
        }, null, 8, ["edit-data", "opened", "loading", "onSubmit"])
      ])
    ])
  ], 64))
}
}

})